const { getPageUrl } = require("./pageUrl")

exports.getHrefLang = (frontmatter) => {
  const { language } = frontmatter;
  return {
    language,
    url: getPageUrl(frontmatter)
  }
}